import React from 'react';
import './aboutus.css';
import { FaGraduationCap, FaUsers, FaChartLine, FaAward, FaBook, FaGlobeAsia } from 'react-icons/fa';
import { FaChalkboardTeacher, FaHandshake } from 'react-icons/fa';

const AboutUs = () => {
  // Statistics data
  // const stats = [
  //   { number: '50+', label: 'Academic Programs', icon: <FaGraduationCap /> },
  //   { number: '10,000+', label: 'Students', icon: <FaUsers /> },
  //   { number: '95%', label: 'Graduation Rate', icon: <FaChartLine /> },
  //   { number: '30+', label: 'Years of Excellence', icon: <FaAward /> }
  // ];

  // Milestones timeline
  const milestones = [
    { year: '2020', title: 'Founded as Technical Institute', description: 'Established with three technical programs' },
    { year: '2021', title: 'Upgraded to Polytechnic', description: 'Recognized as a premier polytechnic institution' },
    { year: '2022', title: 'First International Collaboration', description: 'Partnered with universities in Japan and Singapore' },
    { year: '2023', title: 'Achieved University Status', description: 'Became Asian Polytechnic Campus with degree-granting authority' },
    { year: '2024', title: 'Smart Campus Initiative', description: 'Implemented full digital transformation' }
  ];

  return (
    <div className="about-page">
      {/* Hero Banner */}
      <section className="about-hero">
        <div className="hero-content">
          <h1 className='heading-aboutus'>About Asian Polytechnic Campus</h1>
          <p className='para-aboutus'>Shaping futures through innovation, excellence, and opportunity since 2020</p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <h2>Our Mission</h2>
            <p>To provide transformative education that combines rigorous academics with practical skills, preparing students to excel in their careers and contribute meaningfully to society.</p>
            
            <h2>Our Vision</h2>
            <p>To be recognized as Asia's leading polytechnic institution, known for innovation, industry partnerships, and graduate employability.</p>
          </div>
          <div className="mission-image">
            <img src="/logo192.png" alt="APC Campus Aerial View" />
          </div>
        </div>
      </section>

<section className="apc-about">
  <div className="about-container">
    <div className="about-content">
      <h2 className="about-title">Shape Your Future at Asian Polytechnic Campus</h2>
      
      <div className="about-highlights">
        <div className="highlight-item">
          <div className="highlight-icon">
            <FaGraduationCap />
          </div>
          <p>15+ industry-aligned diploma and degree programs</p>
        </div>
        
        <div className="highlight-item">
          <div className="highlight-icon">
            <FaChalkboardTeacher />
          </div>
          <p>90% of faculty with real-world industry experience</p>
        </div>
        
        <div className="highlight-item">
          <div className="highlight-icon">
            <FaHandshake />
          </div>
          <p>Partnerships with 50+ leading tech companies</p>
        </div>
      </div>
      
      <p className="about-description">
        At Asian Polytechnic Campus (APC), we don't just educate - we transform. As Sri Lanka's fastest-growing 
        technical education provider, we've pioneered an immersive learning model that blends cutting-edge 
        academics with hands-on industry experience. Our state-of-the-art campus in Colombo features 
        next-generation labs, innovation hubs, and collaborative spaces designed to spark creativity and 
        technical mastery.
      </p>
      
      <p className="about-description">
        What sets APC apart is our <strong>Career-Ready Guarantee</strong> - every program includes internships, 
        industry certifications, and career coaching. Our graduates leave not just with qualifications, 
        but with portfolios of real projects and connections to launch rewarding careers. With 87% of our 
        alumni employed within 3 months of graduation, APC is your proven pathway to success in the digital 
        economy.
      </p>
      

    </div>
    
    <div className="about-image">
      <div className="image-wrapper">
        <img 
          src="/apc-about.jpg" 
          alt="APC Modern Campus Facilities" 
          className="main-image"
        />
      </div>
    </div>
  </div>
</section>



      {/* Quick Stats */}
      {/* <section className="stats-section">
        <div className="container">
          {stats.map((stat, index) => (
            <div className="stat-card" key={index}>
              <div className="stat-icon">{stat.icon}</div>
              <h3>{stat.number}</h3>
              <p>{stat.label}</p>
            </div>
          ))}
        </div>
      </section> */}

      {/* History Timeline */}
      <section className="timeline-section">
        <div className="container">
          <h2>Our Journey</h2>
          <div className="timeline">
            {milestones.map((milestone, index) => (
              <div className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
                <div className="timeline-content">
                  <span className="timeline-year">{milestone.year}</span>
                  <h3>{milestone.title}</h3>
                  <p>{milestone.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    
      {/* Academic Excellence */}
      <section className="academics-section">
        <div className="container">
          <h2>Academic Excellence</h2>
          <div className="academics-grid">
            <div className="academic-card">
              <FaBook className="academic-icon" />
              <h3>Industry-Aligned Curriculum</h3>
              <p>Programs designed with input from leading employers and updated annually</p>
            </div>
            
            <div className="academic-card">
              <FaGlobeAsia className="academic-icon" />
              <h3>Global Recognition</h3>
              <p>Accredited by 7 international education bodies and 12 professional associations</p>
            </div>
            
            <div className="academic-card">
              <FaUsers className="academic-icon" />
              <h3>Expert Faculty</h3>
              <p>80% of our faculty hold terminal degrees with industry experience</p>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
};

export default AboutUs;